<template>
  <div class="mx-auto max-w-2xl">
    <form
      ref="form"
      action="/member_sign_offs"
      accept-charset="UTF-8"
      method="post"
    >
      <div class="stack-mt-12">
        <member-form-field
          v-for="field in form"
          @update:modelValue="fieldChange(field)"
          :key="field.id"
          :field="field"
          v-model="field.value"
        >
          forcerefresh
        </member-form-field>
      </div>

      <div class="mt-8 pt-5">
        <member-form-errors
          v-if="formHasErrors"
          :error-fields="errorFields"
        ></member-form-errors>

        <div class="flex justify-end">
          <button
            @click.prevent="submit"
            type="submit"
            class="button button-primary inline-block px-16 py-3"
          >
            {{ buttonText }}
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import MemberFormShared from "./MemberFormShared"
import MemberSignOffConditions from "./MemberSignOffConditions"
export default {
  mixins: [MemberFormShared, MemberSignOffConditions],
  data() {
    return {
      tableName: "member_sign_off",
    }
  },
  methods: {
    fieldChange(field) {
      if (field.id === "member_id") {
        // Redirect to he current URL plus ?member_id=123. Turbo is not available.

        let url = new URL(window.location.href)
        url.searchParams.set("member_id", field.value)

        window.location = url
      }
    },
  },
}
</script>
